import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../Service";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "../../../../Components/CustomInput";
import HeaderMenu from "../../../../Components/HeaderMenu";
import CustomSelect from "../../../../Components/CustomSelect";
import { CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import { Divider, InputLabel } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Icon from "@material-ui/core/Icon";
import Paper from "@material-ui/core/Paper";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import CancelIcon from "@material-ui/icons/Cancel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Select from "@material-ui/core/Select/Select";
import AssignmentModal from "../Employee/Assignment/AssignmentModal";
import DataClient from "../../../../Service/general_data_service";
import ManageAccount from "./manage_email";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import { useSelector, useDispatch } from "react-redux";
import AssignmentDrawer from "../Employee/Assignment/AssignmentDrawer";
import MenuItem from "@material-ui/core/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: "100%",
  },
  indicator: {
    backgroundColor: "white",
  },

  selected: {
    backgroundColor: "green !important",
  },
  stepperButtons: {
    position: "fixed",
    display: "flex",
    justifyContent: "space-between",
    bottom: "3%",
    backgroundColor: "white",
    padding: "10px 0px 20px 0px",
    zIndex: 1,
  },
  formWrapper: {
    background: "#fff",
    width: "400px",
    padding: theme.spacing(3),
  },
  title: {
    textTransform: "capitalize",
  },
  btnSearch: {
    textTransform: "capitalize",
  },
  actionButtons: {
    paddingTop: "35px",
    textAlign: "center",
    "& button": {
      marginRight: "20px",
      //   height:'16px'
    },
  },
  tabStyle: {
    borderRadius: "7px",
    marginRight: "20px",
    height: "16px",
    textTransform: "initial",
  },
  tabRoot: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
    btnSearch: {
      textTransform: "capitalize",
    },
    actionButtons: {
      paddingTop: "35px",
      textAlign: "center",
      "& button": {
        marginRight: "20px",
        //   height:'16px'
      },
    },
    tabStyle: {
      borderRadius: "7px",
      marginRight: "20px",
      height: "16px",
      textTransform: "initial",
    },
    tabRoot: {
      "& .MuiTabs-flexContainer": {
        justifyContent: "flex-start",
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "transparent",
      },
    },
  },
  tabs: {
    color: "rgb(30,30,30)",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: " rgba(7,127,131,0.75)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginRight: 10,
    minWidth: 130,
    textTransform: "capitalize",
    "&:hover,&.Mui-selected": {
      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1,
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(9),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="subtitle1">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
let sectionId = "";
let crfFromId = "";
let sectionName = "";
function a11yProps(index, item) {
  sectionId = item.id;
  crfFromId = item.coaching_request_form_id;
  sectionName = item.section_name;
  //   setCrfSectionId(item.id)
  //   setCrfFormId(item.coaching_request_form_id)
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

function ManageTemplate(props) {
  const theme = useTheme();
  const classes = useStyles();
  const globaluserData = useSelector((state) => state.commonReducer);

  const { action, handleClose, CoachinRequest } = props;
  const [feildName, setFeildName] = useState("");
  const [answerData, setAnswerData] = useState({});

  // const message = useContext(ToastMessageContext);
  const [loading, setLoading] = useState(false);
  // const [CoachinRequest, setCrfSection] = useState([]);
  const [openNewFeildDialog, setOpenNewFeildDialog] = useState(false);
  const [crfStatus, setCrfStatus] = useState(false);
  const [feildValue, setFeildValue] = useState([]);
  const [viewCrf, setViewCrf] = useState([]);
  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const [value, setValue] = React.useState(0);
  const [MailAction, setAction] = useState(null);

  const [assignmentDrawer, setAssignmentDrawer] = useState("");
  const [createAssignmentData, setCreateAssignmentData] = useState(undefined);

  const [orgId, setOrgId] = useState(undefined);
  const [empId, setEmpId] = useState(undefined);

  //create new states for drawer
  const [stepperData, setStepperData] = useState(undefined);
  const [headerType, setHeaderType] = useState(undefined);
  const [headerModal, setHeaderModal] = useState("");
  const [fetchApiFlag, setFetchApiFlag] = useState(false);
  const [headerInputValue, setHeaderInputValue] = useState("");
  const [prgName, setPrgName] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [inputStateVal, setInputStateVal] = useState(null);
  const [empInputValue, setEmpInputValue] = React.useState("");
  const [empData, setEmpData] = useState([]);
  const [empValue, setEmpValue] = React.useState("");
  const [empDetail, setEmpDetail] = React.useState({});
  const [fetchEmployee, setFetchEmployee] = useState(false);

  let quesArr = [];

  const handleChangeData = (fieldId) => {
    // console.log(`fieldId`, fieldId)
  };
  const setInputState = (inputStateValue, inputId) => {
    setAnswerData({ ...answerData, [inputId]: inputStateValue });
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const getData = () => {
    const params = {
      coaching_request_form_id: CoachinRequest.coaching_request_form_id,
      crf_user_id: CoachinRequest.id,
    };
    DataService.getDirectData(`/crf_users/view_crf`, params)
      .then((response) => {
        let listData = response.coaching_request_form.crf_form_sections;
        let prgName = response.coaching_request_form.programme_name;
        let serviceType = response.coaching_request_form.service_type;
        let empId = response.coaching_request_form.employee_id;
        let orgId = response.coaching_request_form.organisation_id;
        setPrgName(prgName);
        setServiceType(serviceType);
        setEmpId(empId);
        setOrgId(orgId);

        setCrfStatus(response.coaching_request_form);
        setViewCrf(listData);
        setLoading(false);
      })

      .catch((err) => {});
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, [CoachinRequest]);
  // useEffect(() => {
  //   setFeildValue(CoachinRequest.module_form_fields);
  // }, [feildValue]);

  const setQuestionChangeState = (selectedItemValue, inputId) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    setAnswerData({
      ...answerData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    inputId == "Business Experience" &&
      setUserData({ ...userData, ref4: selectedItemValue.value });
  };
  const employeeKeys = {
    home_based_location: "home_address",
    level: "level_or_grade",

    contact_details_phone_number: "mobile",
    location: "office_address",
    "office_based_location_(city/country)": "office_address",
    // "Office country": "office_country",
    // "Home city": "home_city",
    // "Home country": "home_country",
    pa_name: "line_manager_pa_name",
    pa_email_address: "line_manager_pa_contact_details",
    "People partner email address": "people_partner_email_address",
    //  "Human capital partner email address":"human_capital_partner_email_address",
    line_manager_email_address: "line_manager_contact_details",
    contact_details_email: "primary_email",
    contact_details_telephone_number: "telephone",
    // Name: "coahee_name",
    // "Job Title": "job_title",
    // // "Job title": "job_title",
    // "Role": "job_role",
    human_capital_partner_email_address: "hr_sponsor_contact_details",
    line_manager_name: "line_manager_name",
    name_of_human_capital_partner: "hr_sponsor_name",
    // "Line manager title": "line_manager_title",
    // "Line manager contact details": "line_manager_contact_details",
    // "LOB leader": "lob_leader",

    // "HR sponsor contact details": "hr_sponsor_contact_details",
    // "HR sponsor name": "hr_sponsor_name",
    // "Name of HRBP":"hr_sponsor_name",
    // "Name of People Partner": "hr_sponsor_name",
    // "HR sponsor title": "hr_sponsor_title",
    // "PA contact details": "pa_contact_details",
    lob_leader: "lob_leader_name",
    // "pa_email_address": "line_manager_pa_contact_details",
    // "Line manager PA name": "line_manager_pa_name"
  };

  const getEmpData = () => {
    setLoading(true);

    if (orgId || value.id) {
      const params = {
        organisation_id: orgId,
        // organisation_id: (value !== null || organisationId) ? value.id ||organisationId : null || null
      };
      DataService.getDirectData(`/coaching_request_forms/employee_list`, params)
        .then((response) => {
          // const params = {
          //   organisation_id: orgId
          //   // organisation_id: (value !== null || organisationId) ? value.id ||organisationId : null || null
          // }
          // DataService.getDirectData(`/employees`, params).then((response) => {

          let listData = response["employees"];
          setEmpData(listData);
          // setFetchEmployee(true)
          setLoading(false);
        })

        .catch((err) => {});
    }
  };
  useEffect(() => {
    setLoading(true);
    getEmpData();
    // setFetchEmployee(false)
  }, [orgId]);
  const getDetail = () => {
    setLoading(true);
    // console.log('refresh1', refresh)
    if (empId || empValue.id) {
      const params = {
        employee_id: empId === null ? empValue.id : empId,
        // organisation_id: (value !== null || organisationId) ? value.id ||organisationId : null || null
      };
      DataService.getDirectData(
        `/coaching_request_forms/employee_detail`,
        params
      )
        .then((response) => {
          // if (orgId) {
          let listData = response.employee_detail;
          setEmpDetail(listData);
          setLoading(false);
          let aswerFileds = {};

          //
          // if (Object.keys(aswerFileds).length) {
          aswerFileds[inputStateVal] =
            empValue.id !== undefined ? empValue.id.toString() : empValue.id;
          // aswerFileds['value'] = empValue.id
          // Object.assign(aswerFileds, ...inputStateVal,  ...empValue.id );
          // }
          // setAnswerData({ ...answerData, ...aswerFileds });
          // setUserData({ ...userData, ...aswerFileds });

          // aswerFileds({crf_field_id:inputStateVal, value:empValue.id})
          // console.log('aswerFileds[inputStateVal]=  empValue.id;', Object.assign(aswerFileds, { crf_field_id: inputStateVal, value: empValue.id }))
          const crfFields =
            viewCrf?.filter(
              (selected_field) => selected_field.section_name !== "Description"
            )[value].crf_fields || [];
          crfFields.map((row) => {
            if (
              Object.keys(employeeKeys).includes(row.field_name) &&
              listData[employeeKeys[row.field_name]]
            ) {
              aswerFileds[row.id] = listData[employeeKeys[row.field_name]];
            }
          });
          setAnswerData({ ...answerData, ...aswerFileds });
          setUserData({ ...userData, ...aswerFileds });
          // }
        })

        .catch((err) => {});
    }
  };
  useEffect(() => {
    if (empDetail) {
      if (Object.keys(empDetail).length && Object.keys(viewCrf).length) {
        let aswerFileds = {};

        viewCrf.length > 0 &&
          viewCrf[value].crf_fields.map((row) => {
            if (
              Object.keys(employeeKeys).includes(row.field_name) &&
              empDetail[employeeKeys[row.field_name]]
            ) {
              aswerFileds[row.id] = empDetail[employeeKeys[row.field_name]];
            }
          });
        setAnswerData({ ...answerData, ...aswerFileds });
        setUserData({ ...userData, ...aswerFileds });
      }
    }
  }, [value, empValue, empInputValue]);
  useEffect(() => {
    setLoading(true);
    getDetail();
  }, [empValue, empInputValue, empId]);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [autoCompleteState, setAutoCompleteState] = useState();
  const updateTable = () => {
    setDialogOpen(false);
    setEmpValue(autoCompleteState?.changedValue?.newValue);
    setInputStateVal(autoCompleteState?.changedValue?.rowID);
    setEmpId(autoCompleteState?.changedValue?.employeeID);
  };

  const handleCloseWarning = () => {
    setDialogOpen(false);
    setEmpValue(autoCompleteState.currrentValue?.newValue);
    setInputStateVal(autoCompleteState.currrentValue?.rowID);
    setEmpId(autoCompleteState.currrentValue?.employeeID);
  };

  const handleSubmit = () => {
    setLoading(true);
    let aswerFileds = {};

    aswerFileds[inputStateVal] =
      empValue.id !== undefined ? empValue.id.toString() : empValue.id;
    const crfFields =
      viewCrf?.filter(
        (selected_field) => selected_field.section_name !== "Description"
      )[value]?.crf_fields || [];
    crfFields.map((row) => {
      if (
        Object.keys(employeeKeys).includes(row.field_value) &&
        empData[employeeKeys[row.field_value]]
      ) {
        aswerFileds[row.id] = empData[employeeKeys[row.field_value]];
      }
    });
    setAnswerData({ ...answerData, ...aswerFileds });
    setUserData({ ...userData, ...aswerFileds });
    for (var i in answerData) {
      if (i !== "null") {
        quesArr.push({ crf_field_id: i, value: answerData[i] });
      }
    }
    const statusData = {
      coaching_request_form_id: crfFromId,
      crf_form_section_id: sectionId,
      crf_answers: JSON.stringify(quesArr),
      crf_user_id: CoachinRequest.id,
      // submitted: false,
      //   approval_status:(value + 1) === CoachinRequest.length ? 'pending review by acuity' :''
    };
    DataService.createData(statusData, "crf_answers")
      .then((res) => {
        // if (res.success) {
        if (value + 1 < viewCrf.length) {
          getData();
          setValue(value + 1);
          dispatch(showSnackbar("success", ["Success!"]));
        }
        getData();
        dispatch(showSnackbar("success", ["Success!"]));
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]]));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAck = () => {
    const statusData = {
      approval_status: "Acknowledged",
      id: CoachinRequest.id,
    };

    DataClient.update(statusData, `/crf_users/update_status`)
      .then((res) => {
        if (res?.success) {
          getData();
          props.getCRFList();
          dispatch(showSnackbar("success", ["Success!"]));
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", [["" + err.errors]]));
      });
  };
  const handleCancel = () => {
    const statusData = {
      approval_status: "Declined",
      id: CoachinRequest.id,
    };

    DataClient.update(statusData, `/crf_users/update_status`)
      .then((res) => {
        if (res?.success) {
          getData();
          props.getCRFList();
          dispatch(showSnackbar("success", ["Success!"]));
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        dispatch(showSnackbar("error", [["" + err.errors]]));
      });
  };
  const handleCreateAssignment = (e) => {
    const formData = new FormData();
    formData.append("crf_id", CoachinRequest?.id);
    formData.append("employee_id", empId === null ? " " : empId);
    DataService.createData(formData, "create_assignment")
      .then((res) => {
        if (res?.success) {
          setCreateAssignmentData(res);
          setAssignmentDrawer("create");
          props.getCRFList();
        }
      })
      .catch((error) => {
        dispatch(showSnackbar("error", [["" + error.errors]]));
      });
  };

  return (
    <div>
      <Dialog
        fullScreen
        maxWidth={"xl"}
        disableBackdropClick
        disableEscapeKeyDown
        // style={{ height: '70%' }}
        open={true}
        onClose={handleClose}
        aria-labelledby="base-station-manage"
      >
        <Grid direction="row">
          <Grid xs={12} style={{ textAlign: "left" }}>
            <HeaderMenu />
          </Grid>
        </Grid>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <Grid
            container
            spacing={1}
            alignItems={"center"}
            justify={"flex-start"}
          >
            <Grid item xs={6}>
              Coaching request form
            </Grid>
            {globaluserData?.role === "admin" && (
              <Grid item xs={6}>
                <Button
                  disableElevation
                  onClick={handleCreateAssignment}
                  type="button"
                  variant={"contained"}
                  disabled={
                    crfStatus.approval_Status === "Approved" ||
                    assignmentDrawer === "create"
                      ? true
                      : false
                  }
                  color="primary"
                  style={{ textTransform: "initial" }}
                >
                  {crfStatus.approval_Status === "Approved" ||
                  assignmentDrawer === "create"
                    ? "Assignment approved"
                    : "Approve and create assignment"}
                </Button>
                &nbsp;&nbsp;
                <Button
                  onClick={handleAck}
                  disabled={
                    crfStatus.approval_Status === "Acknowledged" ? true : false
                  }
                  type="button"
                  variant={"contained"}
                  color="primary"
                  style={{ textTransform: "initial" }}
                >
                  {crfStatus.approval_Status === "Acknowledged"
                    ? "Acknowledged"
                    : "Acknowledge CRF"}
                </Button>
                &nbsp;&nbsp;
                <Button
                  disableElevation
                  onClick={() => {
                    setAction(true);
                  }}
                  type="button"
                  variant={"contained"}
                  style={{
                    backgroundColor: "#C71C1C",
                    color: "white",
                    textTransform: "initial",
                  }}
                  startIcon={<MailOutlineIcon />}
                >
                  Mail
                </Button>
                &nbsp;&nbsp;
                <Button
                  disableElevation
                  onClick={handleCancel}
                  disabled={
                    crfStatus.approval_Status === "Decline" ? true : false
                  }
                  type="button"
                  variant={"contained"}
                  style={{ textTransform: "initial" }}
                  // style={{backgroundColor: '#C71C1C', color: 'white',}}
                  startIcon={<CancelIcon />}
                >
                  {crfStatus.approval_Status === "Decline"
                    ? "Cancelled"
                    : "Cancel CRF"}
                </Button>
              </Grid>
            )}
          </Grid>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <div className={classes.root}>
            <div position="">
              {/* <Tabs
                                value={value}
                                onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                classes={{
                                    // indicator: classes.indicator,
                                    // selected: classes.selected
                                    root: classes.tabRoot
                                }}
                            
                                aria-label="full width tabs example"
                            > */}
              <Tabs
                value={value}
                onChange={handleChange}
                classes={{ root: classes.tabRoot }}
              >
                {viewCrf.length > 0 &&
                  viewCrf
                    ?.filter(
                      (selected_field) =>
                        selected_field.section_name !== "Description"
                    )
                    .map((item1, index) => {
                      return (
                        // <Tab classes={{ root: classes.tabs }} label={item.section_name} />

                        <Tab
                          label={item1.section_name}
                          classes={{ root: classes.tabs }}
                          {...a11yProps(index, item1)}
                          style={{ textTransform: "initial" }}
                        />
                        // <Tab
                        //     label={item.section_name}
                        //     // className={classes.tabStyle}
                        //     classes={{ root: classes.tabs }}
                        //     {...a11yProps(index, item)}
                        //     style={{textTransform: 'initial'}}
                        // />
                      );
                    })}
                {/* <Tab label="Item One" {...a11yProps(0)} />
          <Tab label="Item Two" {...a11yProps(1)} />
          <Tab label="Item Three" {...a11yProps(2)} /> */}
              </Tabs>
            </div>
            {viewCrf.length > 0 &&
              viewCrf?.map((item, index) => {
                return (
                  <TabPanel
                    className={classes.demo2}
                    value={value}
                    index={index}
                  >
                    {/* <form onSubmit={handleSubmit}>  */}
                    {viewCrf.length > 0 &&
                      viewCrf
                        ?.filter(
                          (selected_field) =>
                            selected_field.section_name !== "Description"
                        )
                        [value]?.crf_fields.map((row) => (
                          <Grid
                            container
                            direction="row"
                            alignItems="flex-start"
                            style={{ marginBottom: 20 }}
                          >
                            <Grid
                              item
                              xs={
                                row.field_name === "Description"
                                  ? 10
                                  : row.field_type === "text area" ||
                                    row.field_type === "Text area"
                                  ? 12
                                  : 5
                              }
                            >
                              <Typography
                                className={classes.labelText}
                                variant="h2"
                              >
                                {row.field_value}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              style={{
                                paddingTop:
                                  row.field_type === "text area" ||
                                  row.field_type === "Text area"
                                    ? "20px"
                                    : "",
                              }}
                              xs={
                                row.field_type === "text area" ||
                                row.field_type === "Text area"
                                  ? 9
                                  : 4
                              }
                            >
                              <Grid
                                container
                                direction="row"
                                alignItems="center"
                                style={{ marginBottom: 20 }}
                              >
                                <Grid item xs={12}>
                                  {(row.field_type === "text" ||
                                    row.field_type === "Text") &&
                                    row.field_name !== "coahee_name" &&
                                    row.field_name !==
                                      "line_manager_email_address" &&
                                    row.field_name !==
                                      "contact_details_email" &&
                                    row.field_name !== "line_manager_name" &&
                                    row.field_name !== "role" &&
                                    row.field_name !== "location" &&
                                    row.field_name !==
                                      "office_based_location_(city/country)" &&
                                    row.field_name !== "home_based_location" &&
                                    row.field_name !==
                                      "human_capital_partner_email_address" &&
                                    row.field_name !==
                                      "name_of_human_capital_partner" &&
                                    row.field_name !== "lob_leader" &&
                                    row.field_name !== "pa_email_address" &&
                                    // row.field_value !== "LOB leader" &&
                                    // row.field_name !== "line_manager_telephone" &&
                                    row.field_name !==
                                      "contact_details_phone_number" &&
                                    row.field_name !==
                                      "contact_details_telephone_number" &&
                                    row.field_name !== "coahee_job_tittle" &&
                                    row.field_name !== "pa_name" &&
                                    // row.field_name !== "band" &&
                                    row.field_name !== "level" && (
                                      // row.field_value !== "Name" &&
                                      // row.field_value !== "People partner email address" &&
                                      // row.field_value !== "human_capital_partner_email_address" &&
                                      // row.field_value !==  "Line manager email address" &&
                                      // row.field_value !== "Email address" &&
                                      // row.field_value !== "Mobile" &&
                                      // row.field_value !== "Telephone" &&
                                      // row.field_value !== "Grade" &&
                                      // row.field_value !== "HR sponsor contact details" &&
                                      // row.field_value !== "HR sponsor name" &&
                                      // row.field_value !== "Name of People Partner" &&
                                      // row.field_value !== "Name of HRBP" &&
                                      // row.field_value !== "HR sponsor title" &&
                                      // row.field_value !== "LOB leader name" &&
                                      // row.field_value !== "Line manager PA contact details" &&
                                      // row.field_value !== "Line manager PA name" &&
                                      // row.field_value !== "Band" &&
                                      // row.field_value !== "Office city" &&
                                      // row.field_value !== "Home city" &&
                                      // row.field_value !== "Office country" &&
                                      // row.field_value !== "Home country" &&
                                      // row.field_value !== "PA Name" &&
                                      // (row.field_value !== "Role"
                                      // ) &&
                                      // (row.field_value !==
                                      //   "Line manager name") &&
                                      // row.field_value !==
                                      // "Line manager contact details" &&
                                      // row.field_value !==
                                      // "Line manager title" &&
                                      // row.field_value !== "LOB leader" &&
                                      // (row.field_value !== "Job Title") &&
                                      // (row.field_value !== "Job title") &&
                                      // row.field_value !== "Level" &&
                                      // row.field_value !==
                                      // "PA contact details" &&
                                      // row.field_value !== "Level" &&
                                      <CustomInput
                                        defaultValue={row.answer}
                                        id={row.id}
                                        variant="outlined"
                                        placeholder={row.field_value}
                                        parentcall={setInputState}
                                      />
                                    )}
                                  {row.field_name === "coahee_name" && (
                                    <Autocomplete
                                      id="multiple-limit-tags"
                                      options={empData}
                                      getOptionLabel={(option) =>
                                        option.full_name
                                      }
                                      value={
                                        empValue ||
                                        Object.assign(
                                          {},
                                          ...empData.filter(
                                            (v) => v.full_name === row.answer
                                          )
                                        )
                                      }
                                      onChange={(event, newValue) => {
                                        if (newValue === null) {
                                          //Just give a value to a value to avoid null
                                          //e.g. value = ""
                                          newValue = "";
                                        } else if (newValue !== null) {
                                          setDialogOpen(true);
                                        }

                                        setAutoCompleteState({
                                          changedValue: {
                                            newValue: newValue,
                                            rowID: row.id,
                                            employeeID: newValue.id,
                                          },
                                          currentValue: {
                                            newValue: empData?.filter(
                                              (v) => v.full_name === row.answer
                                            )[0],
                                            rowID: row?.id,
                                            employeeID: empData?.filter(
                                              (v) => v.full_name === row.answer
                                            )[0]?.id,
                                          },
                                        });
                                      }}
                                      // inputValue={inputStateVal}
                                      // onInputChange={(event, newInputValue) => {
                                      //   console.log(newInputValue)
                                      //   setInputStateVal("tysu");
                                      // }}
                                      defaultValue={Object.assign(
                                        {},
                                        ...empData.filter(
                                          (v) => v.full_name === row.answer
                                        )
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          classes={{
                                            root: classes.customTextField,
                                          }}
                                          inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: "16px" },
                                          }}
                                          placeholder="Employee name"
                                          // autoFocus
                                          variant="outlined"
                                        />
                                      )}
                                      sx={{ width: "500px" }}
                                    />
                                  )}

                                  {empDetail !== undefined &&
                                    empValue !== null && (
                                      <React.Fragment>
                                        {row.field_name ===
                                          "line_manager_email_address" && (
                                          <div
                                            key={
                                              empDetail.line_manager_contact_details
                                            }
                                          >
                                            <CustomInput
                                              // defaultValue={row.answer === null
                                              //   ? empDetail.primary_email
                                              //   : row.answer}
                                              defaultValue={
                                                empDetail.line_manager_contact_details ===
                                                row.answer
                                                  ? row.answer
                                                  : empDetail.line_manager_contact_details
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {row.field_name ===
                                          "contact_details_email" && (
                                          <div key={empDetail.primary_email}>
                                            <CustomInput
                                              // defaultValue={row.answer === null
                                              //   ? empDetail.primary_email
                                              //   : row.answer}
                                              defaultValue={
                                                empDetail.primary_email ===
                                                row.answer
                                                  ? row.answer
                                                  : empDetail.primary_email
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                              disabled={
                                                (empValue.primary_email ||
                                                  row.answer) &&
                                                row.answer != ""
                                              }
                                            />
                                          </div>
                                        )}
                                        {row.field_name ===
                                          "human_capital_partner_email_address" && (
                                          <div key={empDetail.primary_email}>
                                            <CustomInput
                                              // defaultValue={row.answer === null
                                              //   ? empDetail.primary_email
                                              //   : row.answer}
                                              defaultValue={
                                                empDetail.hr_sponsor_contact_details ===
                                                row.answer
                                                  ? row.answer
                                                  : empDetail.hr_sponsor_contact_details
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {row.field_name ===
                                          "name_of_human_capital_partner" && (
                                          <div key={empDetail.hr_sponsor_name}>
                                            <CustomInput
                                              // defaultValue={row.answer === null
                                              //   ? empDetail.primary_email
                                              //   : row.answer}
                                              defaultValue={
                                                empDetail.hr_sponsor_name ===
                                                row.answer
                                                  ? row.answer
                                                  : empDetail.hr_sponsor_contact_details
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {row.field_value === "People partner email address" && (
                                      <div key={empDetail.people_partner_email_address}>

                                        <CustomInput

                                          // defaultValue={row.answer === null
                                          //   ? empDetail.primary_email
                                          //   : row.answer}
                                          defaultValue={empDetail.people_partner_email_address === row.answer ? row.answer : empDetail.people_partner_email_address}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )}  
                                     {row.field_value === "Human capital partner email address" && (
                                      <div key={empDetail.human_capital_partner_email_address}>

                                        <CustomInput

                                          // defaultValue={row.answer === null
                                          //   ? empDetail.primary_email
                                          //   : row.answer}
                                          defaultValue={empDetail.human_capital_partner_email_address === row.answer ? row.answer : empDetail.human_capital_partner_email_address}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )}   
                                                        
                                    {row.field_value === "Line manager email address" && (
                                      <div key={empDetail.line_manager_email_address}>

                                        <CustomInput

                                          // defaultValue={row.answer === null
                                          //   ? empDetail.primary_email
                                          //   : row.answer}
                                          defaultValue={empDetail.line_manager_email_address === row.answer ? row.answer : empDetail.line_manager_email_address}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {row.field_name ===
                                          "home_based_location" && (
                                          <div key={empDetail.home_address}>
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.home_city
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.home_address ===
                                                row.answer
                                                  ? empDetail.home_address
                                                  : row.answer
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {(row.field_value ===
                                      "Home country") && (
                                        <div key={empDetail.home_country}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.home_country
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.home_country === row.answer ? empDetail.home_country : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                        {/* {(row.field_value ===
                                      "Office country") && (
                                        <div key={empDetail.office_country}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.office_country
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.office_country === row.answer ? empDetail.office_country : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                        {row.field_name === "location" && (
                                          <div key={empDetail.office_address}>
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.office_city
                                              //     : row.answer
                                              // }
                                              // defaultValue={empDetail.office_address === row.answer ? empDetail.office_address : row.answer}
                                              defaultValue={
                                                empDetail.office_address
                                                  ? empDetail.office_address
                                                  : row.answer ===
                                                    empDetail.office_address
                                                  ? row.answer
                                                  : empDetail.office_address
                                              }
                                              // defaultValue={empDetail.office_city }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {(row.field_name ===
                                      "office_based_location_(city/country)") && (
                                        <div key={empDetail.office_address}>
                                          {console.log('row.field_name === :>> ', row.field_name,empDetail.office_city)}
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.office_city
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.office_address === row.answer ? empDetail.office_address : row.answer}
                                            // defaultValue={empDetail.office_city }
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                        {row.field_name ===
                                          "line_manager_name" && (
                                          <div
                                            key={empDetail.line_manager_name}
                                          >
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.line_manager_name
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.line_manager_name
                                                  ? empDetail.line_manager_name
                                                  : row.answer ===
                                                    empDetail.line_manager_name
                                                  ? row.answer
                                                  : empDetail.line_manager_name
                                              }
                                              // defaultValue={empDetail.line_manager_name === row.answer ? empDetail.line_manager_name : row.answer}
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}

                                        {row.field_name === "role" && (
                                          <div key={empDetail.job_role}>
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.job_role
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.job_role ===
                                                row.answer
                                                  ? empDetail.job_role
                                                  : row.answer
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {(row.field_value === "Line manager PA name") && (
                                      <div key={empDetail.line_manager_pa_name}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.line_manager_pa_name
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.line_manager_pa_name === row.answer ? empDetail.line_manager_pa_name : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {/* {row.field_value ===
                                      "Name of Line Manager" && (
                                      <div key={empDetail.home_country}>
                                        <CustomInput
                                          defaultValue={
                                            empValue.home_country ===
                                            row.answer
                                              ? row.answer
                                              : empDetail.home_country
                                          }
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {/* {(row.field_value === "HR sponsor title") && (
                                      <div key={empDetail.hr_sponsor_title}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.hr_sponsor_title
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.hr_sponsor_title === row.answer ? empDetail.hr_sponsor_title : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {row.field_name === "lob_leader" && (
                                          <div key={empDetail.lob_leader_name}>
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.lob_leader_name
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.lob_leader_name ===
                                                row.answer
                                                  ? empDetail.lob_leader_name
                                                  : row.answer
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {row.field_name ===
                                          "pa_email_address" && (
                                          <div
                                            key={
                                              empDetail.line_manager_pa_contact_details
                                            }
                                          >
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.line_manager_pa_contact_details
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.line_manager_pa_contact_details ===
                                                row.answer
                                                  ? empDetail.line_manager_pa_contact_details
                                                  : row.answer
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {(row.field_name === "department") && (
                                      <div key={empDetail.department}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.hr_sponsor_contact_details
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.department === row.answer ? empDetail.department : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {/* {row.field_name ===
                                      "line_manager_name" && (
                                        <div key={empDetail.line_manager_title}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.line_manager_title
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.line_manager_title === row.answer ? empDetail.line_manager_title : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}
                                        {/* {row.field_value ===
                                      "Line manager contact details" && (
                                        <div key={empDetail.line_manager_contact_details}>
                                          <CustomInput
                                            // defaultValue={
                                            //   row.answer === null
                                            //     ? empDetail.line_manager_contact_details
                                            //     : row.answer
                                            // }
                                            defaultValue={empDetail.line_manager_contact_details === row.answer ? empDetail.line_manager_contact_details : row.answer}
                                            id={row.id}
                                            variant="outlined"
                                            placeholder={row.field_value}
                                            parentcall={setInputState}
                                          />
                                        </div>
                                      )} */}

                                        {row.field_name === "pa_name" && (
                                          <div
                                            key={empDetail.line_manager_pa_name}
                                          >
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.pa_contact_details
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.line_manager_pa_name
                                                  ? empDetail.line_manager_pa_name
                                                  : row.answer
                                              }
                                              // defaultValue={empDetail.pa_contact_details === row.answer ? empDetail.pa_contact_details : row.answer}
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {row.field_value === "LOB leader" && (
                                      <div key={empDetail.lob_leader}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.lob_leader
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.lob_leader === row.answer ? empDetail.lob_leader : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}

                                        {row.field_name ===
                                          "contact_details_telephone_number" && (
                                          <div key={empDetail.telephone}>
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.mobile
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.telephone
                                                  ? empDetail.telephone
                                                  : row.answer
                                              }
                                              // defaultValue={empDetail.telephone === row.answer ? empDetail.telephone : row.answer}
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {row.field_name ===
                                          "contact_details_phone_number" && (
                                          <div key={empDetail.mobile}>
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.mobile
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.mobile === row.answer
                                                  ? empDetail.mobile
                                                  : row.answer
                                              }
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}

                                        {row.field_name ===
                                          "coahee_job_tittle" && (
                                          <div key={empDetail.job_title}>
                                            <CustomInput
                                              // defaultValue={empValue.full_name === row.answer ? empDetail.job_title :  row.answer}
                                              id={row.id}
                                              defaultValue={
                                                empDetail.job_title
                                                  ? empDetail.job_title
                                                  : row.answer
                                              }
                                              // defaultValue={empDetail.job_title === row.answer ? empDetail.job_title : row.answer}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {(row.field_value === "Job Title") && (
                                      <div key={empDetail.job_title}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.job_title
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.job_title === row.answer ? row.answer : empDetail.job_title}
                                          // defaultValue={empDetail.job_title === row.answer ?  empDetail.job_title : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {/* {row.field_value === "Telephone" && (
                                      <div key={empDetail.telephone}>
                                        <CustomInput
                                          // defaultValue={ empDetail.telephone}
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.telephone
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.telephone === row.answer ? empDetail.telephone : row.answer}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {/* {row.field_name === "pa_name" && (
                                      <div key={empDetail.pa_name}>
                                        <CustomInput
                                          // defaultValue={ empDetail.pa_name}
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.pa_name
                                          //     : row.answer
                                          // }
                                          // defaultValue={   empDetail.pa_name ? empDetail.pa_name : row.answer}
                                          defaultValue={empDetail.pa_name === row.answer ? row.answer : empDetail.pa_name}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}

                                        {row.field_name === "level" && (
                                          <div key={empDetail.level_or_grade}>
                                            <CustomInput
                                              // defaultValue={
                                              //   row.answer === null
                                              //     ? empDetail.level_or_grade
                                              //     : row.answer
                                              // }
                                              defaultValue={
                                                empDetail.level_or_grade ===
                                                row.answer
                                                  ? empDetail.level_or_grade
                                                  : row.answer
                                              }
                                              // defaultValue={empDetail.level_or_grade}
                                              id={row.id}
                                              variant="outlined"
                                              placeholder={row.field_value}
                                              parentcall={setInputState}
                                            />
                                          </div>
                                        )}
                                        {/* {row.field_name === "band" && (
                                      <div key={empDetail.level_or_grade}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.level_or_grade
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.level_or_grade === row.answer ? empDetail.level_or_grade : row.answer}
                                          // defaultValue={empDetail.level_or_grade}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                        {/* {row.field_value === "Grade" && (
                                      <div key={empDetail.level_or_grade}>
                                        <CustomInput
                                          // defaultValue={
                                          //   row.answer === null
                                          //     ? empDetail.level_or_grade
                                          //     : row.answer
                                          // }
                                          defaultValue={empDetail.level_or_grade === row.answer ? empDetail.level_or_grade : row.answer}
                                          // defaultValue={empDetail.level_or_grade}
                                          id={row.id}
                                          variant="outlined"
                                          placeholder={row.field_value}
                                          parentcall={setInputState}
                                        />
                                      </div>
                                    )} */}
                                      </React.Fragment>
                                    )}
                                  {(row.field_type === "text area" ||
                                    row.field_type === "Text area") && (
                                    <CustomInput
                                      multiline
                                      rows="4"
                                      id={row.id}
                                      InputProps={{
                                        inputComponent: TextareaAutosize,
                                      }}
                                      defaultValue={row.answer}
                                      //   id={crf_answers}
                                      variant="outlined"
                                      parentcall={setInputState}
                                    />
                                  )}

                                  {(row.field_type === "dropdown" ||
                                    row.field_type === "Drop down") &&
                                  row.field_name === "programme_name" ? (
                                    <CustomInput
                                      // id={row.id}

                                      disabled
                                      defaultValue={prgName}
                                      value={prgName}
                                      //   id={crf_answers}
                                      variant="outlined"
                                      // parentcall={setInputState}
                                    />
                                  ) : (
                                    (row.field_type === "dropdown" ||
                                      row.field_type === "Drop down") && (
                                      <CustomSelect
                                        id={row.id}
                                        displayEmpty
                                        variant="outlined"
                                        labelText="Select a value"
                                        defaultValue={row.answer}
                                        itemArr={row.option}
                                        parentcall={setQuestionChangeState}
                                      />
                                    )
                                  )}
                                  {/* {(row.field_type === "dropdown" || row.field_type === "Drop down") && (
                                                                // <Select
                                                                //     helperText="Please select Location"
                                                                //     variant="outlined"
                                                                //     onChange={setQuestionChangeState}
                                                                //     style={{width: "100%"}}
                                                                //     inputProps={{
                                                                //         id: "outlined-age-native-simple",
                                                                //     }}
                                                                // ></Select>


                                                                <Select
                                                                    helperText="Please select Location"
                                                                    variant="outlined"
                                                                    id={row.id}
                                                                    onChange={(e) => setQuestionChangeState(e.target.value, row.id)}
                                                                    defaultValue={row.answer}
                                                                    style={{ width: "100%" }}
                                                                    inputProps={{
                                                                        id: "outlined-age-native-simple",
                                                                    }}
                                                                >
                                                                    {row.dropdown_values && row.dropdown_values.map(base => <MenuItem key={base} value={base}>
                                                                        {base}
                                                                    </MenuItem>)}
                                                                </Select>

                                                            )} */}
                                  {row.field_type === "radio_button" && (
                                    <React.Fragment>
                                      <Grid item xs={12}>
                                        <RadioGroup
                                          row
                                          aria-label="position"
                                          name="rate_type"
                                        >
                                          <FormControlLabel
                                            value="external"
                                            control={<Radio color="primary" />}
                                            label="Yes"
                                            labelPlacement="end"
                                          />
                                          <FormControlLabel
                                            value="internal"
                                            control={<Radio color="primary" />}
                                            label="No"
                                            labelPlacement="end"
                                          />
                                        </RadioGroup>
                                      </Grid>
                                      {/* <Grid item xs={1}>
                                                                <Button  disableElevation 
                                                                    variant="contained"
                                                                    style={{fontSize: '9px',}}
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        //  setAction("create");
                                                                    }}
                                                                >
                                                                    Save
                                                                </Button></Grid> */}
                                    </React.Fragment>
                                  )}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item xs={0}></Grid>
                            <Grid item xs={2}></Grid>
                          </Grid>
                        ))}
                    {/* <Grid container direction="row" alignItems="flex-start">
                      <Grid item xs={10}></Grid>
                      <Grid item xs={2}>
                        <Button
                          disableElevation
                          variant="contained"
                          color="primary"
                          className={classes.btnSearch}
                          onClick={handleSubmit}
                        >
                          {value + 1 === viewCrf.length ? "Save" : "Save"}
                        </Button>
                      </Grid>
                    </Grid> */}

                    {/* </form>  */}
                    {/* {console.log(`item[value]`, CoachinRequest[index].crf_field.map(row=> row.field_name))} */}
                  </TabPanel>
                );
              })}
            <Grid container direction="row" alignItems="flex-start">
              <Grid item xs={10}></Grid>
              <Grid item xs={2}>
                <div className={classes.stepperButtons}>
                  <Button
                    disableElevation
                    disabled={loading}
                    variant="contained"
                    // color="primary"
                    style={{ background: "#EF7000", color: "white" }}
                    className={classes.btnSearch}
                    onClick={handleSubmit}
                  >
                    {loading && (
                      <CircularProgress
                        className={classes.circularProgress}
                        size={20}
                      />
                    )}
                    {value + 1 === viewCrf.length ? "Submit" : "Save"}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
      </Dialog>
      )
      {MailAction && (
        <ManageAccount
          {...props}
          open={MailAction}
          onCloseAssignmentModal={() => {
            setAction(false);
          }}
        />
      )}
      <Dialog open={dialogOpen} onClose={handleCloseWarning}>
        {/* <DialogTitle>Sample Dialog</DialogTitle> */}
        <DialogContent dividers>
          <Typography>
            Are you sure you want to update the details for the coachee?
            Updating will override the details submitted in CRF and replace it
            with data from employee record
          </Typography>
          <Grid container direction="row" alignItems="flex-start">
            <Grid item xs={8}></Grid>
            <Grid item xs={2}>
              <Button
                disableElevation
                // disabled={loading}
                variant="contained"
                // color="primary"
                style={{
                  background: "#EF7000",
                  color: "white",
                  textTransform: "initial",
                }}
                className={classes.btnSearch}
                onClick={updateTable}
              >
                Update
              </Button>
            </Grid>
            <Grid item xs={2}>
              <Button
                disableElevation
                // disabled={loading}
                variant="contained"
                // color="primary"
                // style={{background:"#EF7000",color:"white"}}
                className={classes.btnSearch}
                onClick={handleCloseWarning}
                style={{ textTransform: "initial" }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      {assignmentDrawer === "create" && (
        <AssignmentDrawer
          {...props}
          handleClose={() => setAssignmentDrawer("")}
          currentSelection={{
            ...createAssignmentData,
            id: createAssignmentData?.assignment_id,
          }}
          setStepperData={setStepperData}
          stepperData={stepperData}
          setHeaderModal={setHeaderModal}
          headerModal={headerModal}
          headerType={headerType}
          setHeaderType={setHeaderType}
          setHeaderInputValue={setHeaderInputValue}
          headerInputValue={headerInputValue}
          fetchApiFlag={fetchApiFlag}
          setFetchApiFlag={setFetchApiFlag}
        />
      )}
    </div>
  );
}

export default ManageTemplate;
